import "./App.css";
import {RouterProvider, createBrowserRouter } from "react-router-dom";
import Home from "./pages/home/Home";
import Portoflio from "./pages/portofolio/Portofolio";
import Contact from "./pages/contact/Contact";
import { action } from "./pages/contact/Contact";
import RootLayout from "./pages/RootLayout";
const router  = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout/>,
    children: [
      { index: true, path: "", element: <Home/>},
      {
        path: '/portofolio',
        element: <Portoflio/>
      },
      {
        path: '/contact',
        element: <Contact/>,
        action: action
      }
    ]
  }
]);

function App() {
  return (
    <RouterProvider router={router}/>
  );
}

export default App;
